'use client';
import ArchiveContentDesc from '@/app/_components/archive/ArchiveContentDesc';
import ContactUsWidget from '@/app/_components/widgets/ContactUsWidget';
import SortFilter from '@/app/_components/widgets/SortFilter';
import PriceListAside from '@/app/_components/priceList/PriceListAside';
import Pagination from '@/app/_components/share/Pagination';
import PriceListHeader from '@/app/_components/priceList/PriceListHeader';
import { usePage, usePagesList } from '@/app/_hooks/usePage';
import { useState, useEffect } from 'react';
import { useProductsCategory } from '@/app/_hooks/useProduct';
import { useRouter } from 'next/navigation';
import PriceListTable from './PriceListTable';

export default function PriceListContent({ initialProducts, pageContent }) {
  const [openMobileSide, setOpenMobileSide] = useState(false);
  const { pagesList } = usePagesList(50, 'priceList');

  const router = useRouter();
  let products, filters, setFilters;

  ({ products, filters, setFilters } = useProductsCategory(
    pageContent?.category_id,
    initialProducts.data
  ));

  useEffect(() => {
    setFilters({ ...router.query });
  }, [router]);

  return (
    <div className="container mb-8">
      <PriceListHeader pagesList={pagesList} title={pageContent?.title} />
      <div className="priceListContent flex pt-5 md:pt-10">
        <PriceListAside
          object={pageContent}
          openMobileSide={openMobileSide}
          onCloseModalHandler={() => setOpenMobileSide(false)}
        />
        <div className="price-list-page-content flex-1">
          <div className="lg:hidden">
            <ContactUsWidget />
          </div>
          <div>
            <SortFilter
              sort={filters?.sort}
              setOpenMobileSide={() => setOpenMobileSide(true)}
            />
          </div>
          <PriceListTable
            products={products}
            currentPage={filters?.page ? parseInt(filters?.page) : 1}
            slug={pageContent?.url}
          />
          {products.last_page != 1 && (
            <Pagination
              itemsPerPage={20}
              totalItems={initialProducts.total}
              currentPage={filters?.page ? parseInt(filters?.page) : 1}
            />
          )}

          {pageContent?.content && (
            <div className="price-list-desc border border-light-gray-300 rounded-md py-12 px-6 mt-12">
              <ArchiveContentDesc content={pageContent?.content} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
